import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IrsipModel } from '../models/Irsip-model';

/** Session key must match `IpfpComponent` / dashboard-data-table (main wizard tab). */
export const IPFP_MAIN_TAB_SESSION_KEY = 'ipfpMainTabIndex';

export interface IpfpApplicationContext {
	applicationId: any;
	acronym: string;
	taskName: string;
	formView: string;
	statusCodeId: any;
	isAdmin: boolean;
	application: any;
}

@Injectable({
  providedIn: 'root'
})
export class IpfpDataService {

	public applicationId: number;
	public acronym: string;
	public taskName: string;
	public formView: string;
	public statusCodeId
	public isAdmin: boolean;
	public application: any;
	public isBatchActive: boolean;
	public isSaveOnly: Boolean;
	public isCategory1: Boolean;
	public isInRevision: Boolean;
	public irsip: IrsipModel;
	constructor() {
		this.restoreApplicationContext();
	}

	public statementsSubmitted: boolean = false;

	private readonly ipfpFromSideMenu$ = new Subject<void>();
	/** Fires when user opens IPFP from the side menu — reset wizard tab even if the route reuses the same component. */
	public readonly ipfpOpenedFromSideMenu$ = this.ipfpFromSideMenu$.asObservable();

	private readonly storageKey = 'formViewFromSideMenuIPFP';
	private readonly applicationContextStorageKey = 'ipfpData';
  
	public setFormViewFromSideMenu(value: boolean): void {
	  localStorage.setItem(this.storageKey, JSON.stringify(value));
	}
	
	public getFormViewFromSideMenu(): boolean {
	  const storedValue = localStorage.getItem(this.storageKey);
	  return storedValue ? JSON.parse(storedValue) : false;
	}

	/** Call when user clicks IPFP in the side menu: clear persisted tab index and notify the form to start at Guidelines. */
	public notifyIpfpOpenedFromSideMenu(): void {
		sessionStorage.removeItem(IPFP_MAIN_TAB_SESSION_KEY);
		this.statementsSubmitted = false;
		this.ipfpFromSideMenu$.next();
	}
	 


	public setApplicationId(id, acronym, formView?,isAdmin?,application?,taskName?, statusCodeId?) {
	  this.applicationId = id;
	  this.acronym = acronym;
	  this.taskName = taskName;
	  this.formView = formView;
	  this.statusCodeId = statusCodeId;
	  this.application = application;
	  this.isAdmin = isAdmin;
	  this.persistApplicationContext();
	}

	public getApplicationContext(): IpfpApplicationContext | null {
		if (!this.hasMeaningfulValue(this.applicationId) &&
			!this.hasMeaningfulValue(this.formView) &&
			!this.hasMeaningfulValue(this.statusCodeId) &&
			!this.hasMeaningfulValue(this.application)) {
			return null;
		}

		return {
			applicationId: this.applicationId,
			acronym: this.acronym,
			taskName: this.taskName,
			formView: this.formView,
			statusCodeId: this.statusCodeId,
			isAdmin: this.isAdmin,
			application: this.application,
		};
	}

	private persistApplicationContext(): void {
		const context = {
			applicationId: this.applicationId,
			acronym: this.acronym,
			taskName: this.taskName,
			formView: this.formView,
			statusCodeId: this.statusCodeId,
			isAdmin: this.isAdmin,
			application: this.application,
		};

		if (!this.hasMeaningfulValue(context.applicationId) &&
			!this.hasMeaningfulValue(context.formView) &&
			!this.hasMeaningfulValue(context.statusCodeId) &&
			!this.hasMeaningfulValue(context.application)) {
			localStorage.removeItem(this.applicationContextStorageKey);
			return;
		}

		localStorage.setItem(this.applicationContextStorageKey, JSON.stringify(context));
	}

	private restoreApplicationContext(): void {
		const storedValue = localStorage.getItem(this.applicationContextStorageKey);
		if (!storedValue || storedValue === 'null' || storedValue === 'undefined') {
			return;
		}

		try {
			const parsed = JSON.parse(storedValue);
			if (!parsed || typeof parsed !== 'object') {
				localStorage.removeItem(this.applicationContextStorageKey);
				return;
			}

			this.applicationId = parsed.applicationId;
			this.acronym = parsed.acronym;
			this.taskName = parsed.taskName;
			this.formView = parsed.formView;
			this.statusCodeId = parsed.statusCodeId;
			this.application = parsed.application;
			this.isAdmin = parsed.isAdmin;
		} catch (error) {
			localStorage.removeItem(this.applicationContextStorageKey);
		}
	}

	private hasMeaningfulValue(value: any): boolean {
		return value !== undefined &&
			value !== null &&
			value !== '' &&
			value !== 'null' &&
			value !== 'undefined';
	}
	// public setIRSIPAppplication(data){
	// 	this.irsip = data;
	// }
}
